<div class="flex gap-4 justify-between">
  @if (store.loading$()) {
    @for (i of [1, 2, 3, 4]; track i) {
      <div class="w-full h-[115px]">
        <ngx-skeleton-loader [theme]="{ width: '100%', height: '115px', 'border-radius': '16px' }" />
      </div>
    }
  } @else {
    @for (stat of store.stats$(); track stat.name) {
      <app-kpi-card
        class="w-full"
        [current]="stat.value"
        [total]="stat.maxValue"
        [unit]="stat.unit"
        [labelKey]="stat.name"
      />
    }
  }
</div>
